// This is all you.
import { Datepicker } from 'vanillajs-datepicker';
import cs from 'vanillajs-datepicker/locales/cs';
Object.assign(Datepicker.locales, cs);

// Header
let scrollpos = window.scrollY
const header = document.querySelector(".header")

const add_class_on_scroll = () => header.classList.add("header--light")
const remove_class_on_scroll = () => header.classList.remove("header--light")

window.addEventListener('scroll', function() {
  scrollpos = window.scrollY;

  if (scrollpos >= 150) { add_class_on_scroll() }
  else { remove_class_on_scroll() }
})

// Homepage First Slider
if(document.getElementsByClassName("my-slider").length !== 0 ) {
  var slider = tns({
    container: '.my-slider',
    items: 1,
    slideBy: 'page',
    autoplay: true
  });
}

// Homepage Second Slider
if(document.getElementsByClassName("apartments-slider").length !== 0) {
  var slider2 = tns({
    container: '.apartments-slider',
    items: 1,
    slideBy: 1,
    autoplay: false,
    nav: true,
    controls: true,
    controlsContainer: "#customize-controls"
  });
}

// Homepage Third Slider (Gallery)
if(document.getElementsByClassName('homepage-gallery').length !== 0) {
  var slider3 = tns({
    container: '.homepage-gallery',
    items: 1,
    slideBy: 1,
    autoplay: true,
    nav: false,
    controls: true,
    controlsContainer: "#gallery-customize-controls",
    rewind: true,
    responsive: {
      415: {
        items: 2
      },
      768: {
        items: 3
      },
      1024: {
        items: 4
      }
    }
  });
}

// Apartments Details Slider (Gallery)
if(document.getElementsByClassName('detail-gallery').length !== 0) {
  console.log('hi')
  var slider4 = tns({
    container: '.detail-gallery',
    items: 1,
    slideBy: 1,
    autoplay: false,
    nav: false,
    controls: true,
    controlsContainer: "#gallery-customize-controls",
    rewind: true,
    responsive: {
      415: {
        items: 2
      },
      768: {
        items: 3
      },
    }
  });
}

// Apartments list
if(document.getElementsByClassName("apartments-list-slider-1").length !== 0) {
  var apartments_list_slider = tns({
    container: '.apartments-list-slider-1',
    items: 1,
    slideBy: 1,
    autoplay: true,
    nav: true,
    controls: true,
    controlsContainer: ".apartments-list-slider-1-controls"
  });
}

if(document.getElementsByClassName("apartments-list-slider-2").length !== 0) {
  var apartments_list_slider = tns({
    container: '.apartments-list-slider-2',
    items: 1,
    slideBy: 1,
    autoplay: true,
    nav: true,
    controls: true,
    controlsContainer: ".apartments-list-slider-2-controls"
  });
}

if(document.getElementsByClassName("apartments-list-slider-3").length !== 0) {
    var apartments_list_slider = tns({
        container: '.apartments-list-slider-3',
        items: 1,
        slideBy: 1,
        autoplay: true,
        nav: true,
        controls: true,
        controlsContainer: ".apartments-list-slider-3-controls"
    });
}

/* Datepickers */
const datepickerSettings = { language: 'cs' }
const dateFromElement = document.querySelector('input[name="dateFrom"]');
const dateToElement = document.querySelector('input[name="dateTo"]');
const dateFrom = new Datepicker(dateFromElement, datepickerSettings);
const dateTo = new Datepicker(dateToElement, datepickerSettings);
